(function () {
  // Gallery: thumbnail -> main image
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('#PdpMainImage');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (main && full) {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = full;
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  // Quantity stepper
  var qty = document.querySelector('[data-qty]');
  if (qty) {
    var input = qty.querySelector('[data-qty-input]');
    qty.querySelector('[data-qty-minus]').addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    qty.querySelector('[data-qty-plus]').addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }

  // Accordions
  var box = document.querySelector('[data-accordions]');
  if (box) {
    box.querySelectorAll('[data-accordion-head]').forEach(function (head) {
      var body = head.parentElement.querySelector('[data-accordion-body]');
      head.addEventListener('click', function () {
        var open = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', String(!open));
        body.hidden = open;
      });
    });
  }
})();
